// Constantes globais da aplicação
export const SUPPORT_WHATSAPP_URL = 'https://wa.me/5511985441304?text=Ol%C3%A1%2C%20preciso%20de%20suporte%20em%20chancelafacil.com.br';

// Função para abrir o WhatsApp do suporte
export const openSupportWhatsApp = () => {
  window.open(SUPPORT_WHATSAPP_URL, '_blank');
};
